export const resolveNextPageParam = (
  lastPage: { pagination: { totalPages: number } },
  pages: unknown[]
) =>
  pages.length < lastPage.pagination.totalPages ? pages.length + 1 : undefined;
